import React, { useState } from "react";
import { CreatorCard, UserBio, CreatorTitle, CreatorCardBody } from "shared/Slider/styled";
import { CardImage, PaymentBackground, PlayVideo } from "styles/MainCards.styled";
import cloudfront from "helpers/cloudfront";
import { useRouter } from "next/router";
import { Icon } from "components/SvgIcons";
import CreatorVideo from "./CreatorVideo";
import { getImageName } from "../../../helpers";
import { getMainVideo } from "../../../helpers/video";

const TemplateForCreators = ({ context, item }) => {
  const router = useRouter();
  const [showVideo, setShowVideo] = useState();

  const buinessName =
    item.business_name?.length > 20 ? item.business_name.substring(0, 20) + "..." : item.business_name;

  const names = `${item.first_name} ${item.last_name}`;
  const renderName = names.length > 20 ? names.substring(0, 20) + "..." : names;

  const toCreatorPage = () => {
    router.push(item.slug ? `/${item.slug}` : `/${context}/${item.id}`);
  };

  const openVideo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowVideo(true);
  };

  const closeVideo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowVideo(false);
  };

  return (
    <CreatorCard onClick={toCreatorPage}>
      <CardImage>
        <img
          className="cloudfront"
          src={
            item.main_image ? cloudfront({ href: item.main_image, size: "large" }) : "/images/mocks/creator-mock.png"
          }
          id={item.id}
          data-path={context}
          alt={getImageName(item.main_image)}
        />

        {getMainVideo(item) && (
          <PlayVideo onClick={openVideo}>
            <Icon icon="play_icon" />
          </PlayVideo>
        )}
        {showVideo && <CreatorVideo item={item} onClose={closeVideo} toCreatorPage={toCreatorPage} />}

        {item.location && (
          <PaymentBackground className="creator">
            <Icon icon="location" />

            <div>{item.location.length > 18 ? item.location.substring(0, 18) + "..." : item.location}</div>
          </PaymentBackground>
        )}
      </CardImage>
      <CreatorCardBody>
        <CreatorTitle id={item.id} data-path={context}>
          {item.show_business_name ? buinessName : renderName}
        </CreatorTitle>
        {item.bio && <UserBio>{item.bio.length > 105 ? item.bio.substring(0, 95) + "..." : item.bio}</UserBio>}
      </CreatorCardBody>
    </CreatorCard>
  );
};

export default TemplateForCreators;
